import { fromJS, Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  cities: null,
  regions: null,
  standardizedPositions: null,
  categories: null,
  educationCategories: null,
  educationLevels: null,
  languages: null,
  languageProficiencies: null,
  computerSkills: null,
  positionExperiences: null,
  skillLevels: null,
  driversLicenses: null,
  licenses: null,
  skills: null,
  candidateSearchListsLoading: false,
});

export default function listReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_LISTS_DONE: {
      let newState = state;
      Object.keys(action.payload).forEach((key) => {
        newState = newState.set(key, fromJS(action.payload[key]));
      });
      return newState;
    }
    case actions.FETCH_CANDIDATE_SEARCH_LISTS_START: {
      return state.set('candidateSearchListsLoading', true);
    }

    case actions.FETCH_CANDIDATE_SEARCH_LISTS_DONE: {
      let newState = state;
      Object.keys(action.payload).forEach((key) => {
        newState = newState.set(key, fromJS(action.payload[key]));
      });
      return newState.set('candidateSearchListsLoading', false);
    }
    case actions.LOGOUT:
      return initState;
    default:
      return state;
  }
}
